import styled from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';

const Toolbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.6rem;
  margin: 2rem 0;
`;

const Hint = styled.p`
  margin: 0;
  font-size: 1.4rem;
  color: ${pickColor('grayLabel')};
`;

// a size no longer in the scale, kept for the order lines that hold it
const InactiveSize = styled.span`
  color: ${pickColor('grayLabel')};
  text-decoration: line-through;
  cursor: help;
`;

// Narrow size columns: on a smaller screen the (empty) sort-icon slot of a header wrapped under
// its text and lifted that header out of line with the wider ones; keep headers and sizes on one line
const ScalesTable = styled.div`
  th,
  td {
    white-space: nowrap;
  }
`;

const Message = styled.p`
  margin: 2rem 0;
  font-size: 1.6rem;
`;

export { Hint, InactiveSize, Message, ScalesTable, Toolbar };
